import Vue from 'vue'
import Router from 'vue-router'
import Toc from '@/components/Toc'
import Chapter from '@/components/Chapter'
import Essay from '@/components/Essay'
import ViewWrapper from '@/components/ViewWrapper'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      // Home Page / TOC
      path: '/',
      component: Toc
    },
    {
      // Chapter page
      path: '/chapter/:id',
      component: Chapter,

      // disable routes for any chapters except 1-3 for now
      beforeEnter: (to, from, next) => {
        if (!(Number(to.params.id) <= 3)) {
          next('/')
        } else {
          next()
        }
      }
    },
    {
      // Essay Text
      path: '/chapter/:id/essay',
      component: Essay,

      // disable routes for any chapters except 1-3 for now
      beforeEnter: (to, from, next) => {
        if (!(Number(to.params.id) <= 3)) {
          next('/')
        } else {
          next()
        }
      }
    },
    {
      // Deepzoom score viewer
      path: '/chapter/:id/score/:index',
      component: ViewWrapper,

      // disable routes for any chapters except 1-3 for now
      beforeEnter: (to, from, next) => {
        if (!(Number(to.params.id) <= 3)) {
          next('/')
        } else {
          next()
        }
      }
    }
  ],

  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js